import { useEffect, useState } from "react";
import api from "../services/api";

export default function UsersPage() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");
  const [page,    setPage]    = useState(1);
  const [total,   setTotal]   = useState(0);
  const PER_PAGE = 10;

  const fetchUsers = async (searchVal = search, pageVal = page) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        limit:  PER_PAGE,
        offset: (pageVal - 1) * PER_PAGE,
        ...(searchVal ? { search: searchVal } : {}),
      });
      const res = await api.get(`/users?${params}`);
      setUsers(res.data.users ?? res.data);
      setTotal(res.data.total ?? res.data.length);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchUsers(); }, []);

  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
    fetchUsers(val, 1);
  };

  const deleteUser = async (id) => {
    if (!window.confirm("Supprimer cet utilisateur ?")) return;
    try {
      await api.delete(`/users/${id}`);
      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  const totalPages = Math.ceil(total / PER_PAGE);

  const formatDate = (d) => {
    if (!d) return "—";
    return new Date(d).toLocaleDateString("fr-FR");
  };

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: 
"space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" 
}}>👤 Utilisateurs</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Clients 
de la plateforme</p>
        </div>
        <div style={{ fontSize: 12, padding: "4px 14px", borderRadius: 20, 
background: "#E6F1FB", color: "#185FA5", border: "0.5px solid #B5D4F4" }}>
          👥 {total} utilisateurs
        </div>
      </div>

      {/* Recherche */}
      <div style={{ marginBottom: "1.25rem" }}>
        <input
          type="text"
          placeholder="🔍 Rechercher par téléphone..."
          value={search}
          onChange={e => handleSearch(e.target.value)}
          style={{
            width: 280, padding: "9px 14px", borderRadius: 8,
            border: "0.5px solid #ddd", fontSize: 13, outline: "none",
            color: "#0B3C5D",
          }}
        />
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "0.5px solid #e5e5e5", 
borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              {["ID", "Téléphone", "Vérifié", "Inscrit le", 
"Actions"].map(h => (
                <th key={h} style={{ padding: "12px 14px", textAlign: 
"left", fontSize: 12, fontWeight: 500, color: "#fff" }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} style={{ padding: 30, textAlign: "center", 
color: "#aaa" }}>
                  Chargement...
                </td>
              </tr>
            ) : users.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 30, textAlign: "center", 
color: "#aaa" }}>
                  Aucun utilisateur trouvé
                </td>
              </tr>
            ) : users.map(u => (
              <tr key={u.id} style={{ borderBottom: "0.5px solid #f0f0f0" 
}}>

                <td style={{ padding: "12px 14px" }}>
                  <span style={{ fontSize: 11, padding: "2px 8px", 
borderRadius: 6, background: "#f0f0f0", color: "#888" }}>
                    #{u.id}
                  </span>
                </td>

                <td style={{ padding: "12px 14px" }}>
                  <div style={{ display: "flex", alignItems: "center", 
gap: 10 }}>
                    <div style={{
                      width: 32, height: 32, borderRadius: "50%",
                      background: "#E6F1FB", color: "#185FA5",
                      fontSize: 11, fontWeight: 600,
                      display: "flex", alignItems: "center", 
justifyContent: "center",
                    }}>
                      {u.telephone?.slice(-2) ?? "??"}
                    </div>
                    <span style={{ fontSize: 13, fontWeight: 500, color: 
"#0B3C5D" }}>
                      {u.telephone}
                    </span>
                  </div>
                </td>

                <td style={{ padding: "12px 14px" }}>
                  <span style={{
                    fontSize: 11, padding: "3px 10px", borderRadius: 20, 
fontWeight: 500,
                    background: u.verified ? "#EAF3DE" : "#FAEEDA",
                    color:      u.verified ? "#3B6D11"  : "#854F0B",
                  }}>
                    {u.verified ? "✅ Vérifié" : "⏳ En attente"}
                  </span>
                </td>

                <td style={{ padding: "12px 14px", fontSize: 13, color: 
"#888" }}>
                  {formatDate(u.created_at)}
                </td>

                <td style={{ padding: "12px 14px" }}>
                  <button
                    onClick={() => deleteUser(u.id)}
                    style={{
                      fontSize: 12, padding: "5px 12px", borderRadius: 6,
                      border: "none", background: "#FCEBEB", color: 
"#A32D2D",
                      cursor: "pointer",
                    }}
                  >
                    🗑 Supprimer
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", gap: 6, marginTop: "1.25rem", 
alignItems: "center" }}>
        <span style={{ fontSize: 13, color: "#888", marginRight: 8 }}>
          Page {page} / {totalPages || 1}
        </span>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i} onClick={() => { setPage(i + 1); 
fetchUsers(search, i + 1); }} style={{
            width: 32, height: 32, borderRadius: 6, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: page === i + 1 ? "#0B3C5D" : "#fff",
            color:      page === i + 1 ? "#fff"     : "#888",
            fontSize: 13,
          }}>{i + 1}</button>
        ))}
      </div>

    </div>
  );
}
